export const MAX_USER_ATTACHMENT_BYTES = 5 * 1024 * 1024

export function isUserAttachmentWithinLimit(size: number): boolean {
  return size <= MAX_USER_ATTACHMENT_BYTES
}
